import React from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import { formatDiamondShape, formatJewelryType, formatCarat } from '../../utils/format-labels'

const headerClasses = props => [
  css.header,
  props.small ? css.small : ''
].join(' ')

const headerDetailsClasses = props => [
  css.headerDetails,
  props.small ? css.small : ''
].join(' ')

const ItemHeader = props => (
  <div>
    <ItemName {...props} />
    <ItemStats {...props} />
  </div>
)

const ItemName = props => (
  <div className={headerClasses(props)}>
    {props.type === 'diamond' ? <DiamondName {...props} /> : <JewelryName {...props} />}
  </div>
)

const ItemStats = props => (
  <p className={headerDetailsClasses(props)}>
    {props.type === 'diamond' ? <DiamondStats {...props} /> : <JewelryStats {...props} />}
  </p>
)

const DiamondName = props => (
  <span>
    Kimberfire<sup>&reg;</sup> #{props.data['Stock Number']}
  </span>
)

const DiamondStats = props => (
  <span>
    {formatCarat(props.data['Weight'])} Carat · {formatDiamondShape(props.data['Shape'])} · {props.data['Color'] ? props.data['Color'] : props.data['Fancy Color']} · {props.data['Clarity']}
  </span>
)

const JewelryName = props => {
  let jewelryType = props.data ? formatJewelryType(props.data.jewellery_type) : null
  return (
    <span>
      Jewellery {props.index || ''}
      {jewelryType && ` (${jewelryType})`}
    </span>
  )
}

const JewelryStats = props => {
  // if the jewelry type is other than stock item, then display the primary_diamond shape + primary_metal_type
  // otherwise (is stock item), display the content of item_description
  return (
    <span>
      {props.description}
    </span>
  )
}

// PropTypes

const typeRequirement = PropTypes.oneOf(['jewelry', 'diamond']).isRequired

ItemHeader.propTypes = {
  type: typeRequirement
}

ItemName.propTypes = {
  type: typeRequirement
}

ItemStats.propTypes = {
  type: typeRequirement
}

DiamondName.propTypes = {
  data: PropTypes.shape({
    'Stock Number': PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  }).isRequired
}

DiamondStats.propTypes = {
  data: PropTypes.shape({
    'Weight': PropTypes.number,
    'Shape': PropTypes.string,
    'Clarity': PropTypes.string,
    'Color': PropTypes.string
  }).isRequired
}

JewelryName.propTypes = {
  index: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  data: PropTypes.object
}

JewelryStats.propTypes = {
  data: PropTypes.object.isRequired
}

export { ItemHeader as default, ItemName, ItemStats, DiamondName, DiamondStats, JewelryName, JewelryStats }



// WEBPACK FOOTER //
// ./src/components/item-header/index.js